import React from 'react';
import Link from '@base/lib/ThemeLink';
import { RouteEnum } from 'pro/config/routers';
import { useTrans } from 'base/utils/i18n';

export type PureBreadcrumbsItem = {
    name: string;
    url?: string;
};

type PureBreadcrumbsProps = {
    className: string;
    list: PureBreadcrumbsItem[];
}

const PureBreadcrumbs: React.FC<PureBreadcrumbsProps> = ({ className, list }) => {
    const { t } = useTrans();
    return list.length === 0 ? null : (
        <div className={className}>
            <Link href={RouteEnum.SHOP}>{t('web_page_link_home')}</Link>
            {list.map((item, index) => (
                <React.Fragment key={index}>
                    <em className="split">/</em>
                    {item.url ? <Link href={item.url}>{item.name}</Link> : <span>{item.name}</span>}
                </React.Fragment>
            ))}
        </div>
    );
}

export default PureBreadcrumbs;